import React from 'react';
import { PageSection, SiteData } from '../../../types';
import { isDarkBackground, getOptimalTextColor, getCardStylesForBackground } from '../../../utils/contrast';

interface SectionProps {
  section: PageSection;
  siteData: SiteData;
}

export const StatsSection: React.FC<SectionProps> = ({ section, siteData }) => {
  const content = section.content || {};
  const style = section.style || {};

  const items = Array.isArray(content.items) ? content.items : [];

  const bgColor = style.backgroundColor || '#F8FAFC';
  const isDark = isDarkBackground(bgColor);
  const cardStyles = getCardStylesForBackground(bgColor);
  const textColor = style.textColor || getOptimalTextColor(bgColor);
  const accentColor = siteData.settings?.accentColor || '#2563EB';

  const anchorId = style.anchorId || style.customId || 'stats';

  return (
    <section
      id={anchorId}
      data-section-id={section.id}
      data-section-type="STATS"
      className="py-16 px-4 sm:px-6 lg:px-8 border-y border-black/5 select-none transition-colors"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      <div className="max-w-7xl mx-auto">
        {items.length === 0 ? (
          <div className="p-8 text-center rounded-2xl border border-dashed border-slate-200 dark:border-slate-800 max-w-sm mx-auto text-xs text-slate-400">
            Henüz istatistik veya başarı metriği eklenmedi.
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 text-center">
            {items.map((item: any, idx: number) => (
              <div
                key={item.id || idx}
                className={`p-6 rounded-3xl border shadow-xs space-y-2 transition hover:-translate-y-1 ${cardStyles.bg} ${cardStyles.border}`}
              >
                <div
                  className="text-3xl sm:text-5xl font-black tracking-tight"
                  style={{ color: accentColor }}
                >
                  {item.title}
                </div>
                <div className={`text-xs sm:text-sm font-semibold ${cardStyles.mutedText}`}>
                  {item.subtitle}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
